'use client';

import { ShieldCheck, Eye, TrendingUp, LifeBuoy } from 'lucide-react';
import { useTranslation } from '@/contexts/LanguageContext';
import { useScrollAnimation, useStaggeredScrollAnimation } from '@/hooks/use-scroll-animation';

export function WhyInvest() {
  const { t } = useTranslation();
  const titleRef = useScrollAnimation('fade-in-up', { threshold: 0.2 });
  const { getItemProps } = useStaggeredScrollAnimation('fade-in-up', { threshold: 0.15, delay: 150 });

  const features = [
    {
      icon: <ShieldCheck className="w-10 h-10 text-primary" />,
      title: t.whyInvest.secure,
      description: t.whyInvest.secureDesc,
    },
    {
      icon: <Eye className="w-10 h-10 text-primary" />,
      title: t.whyInvest.transparent,
      description: t.whyInvest.transparentDesc,
    },
    {
      icon: <TrendingUp className="w-10 h-10 text-primary" />,
      title: t.whyInvest.passive,
      description: t.whyInvest.passiveDesc,
    },
    {
      icon: <LifeBuoy className="w-10 h-10 text-primary" />,
      title: t.whyInvest.support,
      description: t.whyInvest.supportDesc,
    },
  ];

  return (
    <section className="py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div
          ref={titleRef.ref}
          style={titleRef.style}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold">{t.home.whyInvestTitle}</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
          {features.map((feature, idx) => {
            const itemProps = getItemProps(idx);
            return (
              <div key={feature.title} {...itemProps} className="flex flex-col items-center p-6 bg-background rounded-lg shadow-sm border">
                <div className="mb-4">{feature.icon}</div>
                <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                <p className="text-muted-foreground">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
